import React from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Row,
  Title,
  TitleItem,
  InnerItem,
  Inner,
} from "./styles/cv-count-styles";

const CvCount = ({ cvCount }) => {
  const {
    cv_opened_count: cvOpenedCount,
    cv_downloaded_count: cvDownloadedCount,
  } = cvCount;

  return (
    <Wrapper>
      <Row>
        <Title>
          <TitleItem>CV Viewed</TitleItem>
          <TitleItem>CV Downloaded</TitleItem>
        </Title>
        <Inner>
          <InnerItem>{cvOpenedCount} times</InnerItem>
          <InnerItem>{cvDownloadedCount} times</InnerItem>
        </Inner>
      </Row>
    </Wrapper>
  );
};

CvCount.propTypes = {
  cvCount: PropTypes.shape({
    cv_opened_count: PropTypes.number,
    cv_downloaded_count: PropTypes.number,
  }).isRequired,
};

export default CvCount;
